import { useQuery } from '@tanstack/react-query';
import { api } from '../../lib/api';

/** Gleicher Takt wie `useNavBadges` — die Query-Keys sind identisch, damit sich
 *  Nav-Badges und ServiceHub einen Cache teilen und kein zusätzlicher Poll entsteht. */
const REFRESH = 120_000;

export interface ServiceHubCounts {
  /** Chat-Konversationen mit ungelesenen Nachrichten. */
  chatUnread: number;
  /** Offene Chats, in denen der Kunde auf eine Antwort wartet (Auto-Nachrichten zählen nicht). */
  chatUnanswered: number;
  /** Noch nicht angefasste Rückrufe (neue verpasste Anrufe). */
  callsOpen: number;
}

export function useServiceHubCounts(): ServiceHubCounts {
  const chats = useQuery({
    queryKey: ['chats-stats'],
    queryFn: () => api.getChatsStats(),
    refetchInterval: REFRESH,
    staleTime: REFRESH,
  });

  const callbacks = useQuery({
    queryKey: ['nav-badge', 'callbacks'],
    queryFn: () => api.getCallbacksStats(),
    refetchInterval: REFRESH,
    staleTime: REFRESH,
  });

  return {
    chatUnread: chats.data?.withUnread ?? 0,
    chatUnanswered: chats.data?.unanswered ?? 0,
    callsOpen: callbacks.data?.open ?? 0,
  };
}
